/**
 * Shared mobile menu link list (label + path). Used by Nav, NavForHome, NavForNotHome.
 * Path is used with navigate() except for mailto links which use <a href>.
 */
export const MOBILE_NAV_LINKS = [
  { label: 'sell', path: '/createpremiummessage' },
  { label: 'post', path: '/postonpremsi' },
  { label: 'for creators', path: '/invitation' },
  { label: 'faq', path: '/faq' },
  { label: 'ambassador program', path: '/ambassador' },
  { label: 'how to use Premsi', path: '/explanation' },
  { label: '$ calculator', path: '/calculator' },
  { label: 'contact', path: 'mailto:contact@premsi.com', isMailto: true },
];
